import Request from './request'

const SimTask = {
  getSimTaskList(params, callback) {
    Request.get('sim-task/index', params).then(callback).catch(this.bad_answer)
  },
  createSimTask(params, callback){
    Request.post('sim-task/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimTaskInfo(id, callback) {
    Request.get('sim-task/view/' + id).then(callback).catch(this.bad_answer)
  },
  getTaskTypes(params, callback) {
    Request.get('sim-task/types', params).then(callback).catch(this.bad_answer)
  }
}
export default SimTask
